import { BellIcon } from '@heroicons/react/24/solid';
import { isBefore } from 'date-fns';
import format from 'date-fns/format';

type LeadReminderBannerProps = {
  due: string;
  variant?: 'banner' | 'chip';
};

export default function LeadReminderBanner({
  due,
  variant = 'banner',
}: LeadReminderBannerProps) {
  const dueDate = new Date(due);
  const overdue = isBefore(dueDate, new Date());
  const formatted = `${format(dueDate, 'do MMM yyyy')} at ${format(dueDate, 'p')}`;

  if (variant === 'chip') {
    return (
      <span
        className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-medium ${
          overdue
            ? 'bg-red-50 text-red-700 ring-1 ring-red-200/80'
            : 'bg-purple-50 text-purple-800 ring-1 ring-purple-200/80'
        }`}
      >
        <BellIcon
          className={`h-3 w-3 flex-shrink-0 ${overdue ? 'text-red-500' : 'text-purple-600'}`}
          aria-hidden="true"
        />
        {overdue ? 'Overdue' : 'Reminder'} ·{' '}
        <time dateTime={due}>{formatted}</time>
      </span>
    );
  }

  return (
    <div
      className={`flex items-center gap-2 rounded-md border px-2.5 py-1.5 ${
        overdue
          ? 'border-red-200 bg-red-50 text-red-800'
          : 'border-purple-200 bg-purple-50 text-purple-900'
      }`}
    >
      <BellIcon
        className={`h-3.5 w-3.5 flex-shrink-0 ${overdue ? 'text-red-500' : 'text-purple-600'}`}
        aria-hidden="true"
      />
      <p className="text-xs font-medium leading-snug">
        {overdue ? 'Overdue' : 'Reminder'}:{' '}
        <time dateTime={due}>{formatted}</time>
      </p>
    </div>
  );
}
